<template>
  <div>
    <con-tab @TwoClick="TwoClick"></con-tab>
    <!--政府云 活动与任务详情-->
    <tackXq></tackXq>
  </div>
</template>

<script>
import ConTab from "../../components/common/ConTab";
import tackXq from "./base/tackXq.vue";
export default {
  name: "tack",
  data() {
    return {};
  },
  created() {},
  methods: {
    TwoClick(item) {
      //console.log(item);
      this.ConList = item;
    },
  },
  components: {
    ConTab,
    tackXq,
  },
};
</script>

<style scoped>
</style>
